import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img03.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#04396c" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Propel your Business to New Heights With TekRevol’s App Developers
              in California
            </h2>
            <p>
              Our tailor-made digital solutions are carefully crafted to align
              perfectly with your unique objectives, enhance your brand's
              visibility, and foster long-lasting connections with your target
              audience. When you choose TekRevol, you don’t have to worry about
              anything as their professional app developers in California will
              take care of everything for you.At TekRevol, we recognize that
              innovation needs expert guidance to transform into brilliance.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#04396c",
                border: "1px solid #04396c",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
